// import Image from "next/image";

// import UserData from "../../../data/user.json";
// import Link from "next/link";
// import { useRouter } from "next/router";

// const User = () => {
//   const router = useRouter();
//   const URL = `${process.env.NEXT_PUBLIC_API_URL}/logout`;

//   const logout = async (e) => {
//     e.preventDefault();
//     window.localStorage.removeItem("user");
//     window.localStorage.removeItem("token");
//     const response = await fetch(URL, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json;charset=UTF-8",
//       },
//     });
//     console.log(response);
//     router.push("/login");
//   };

//   return (
//     <div className="rbt-user-menu-list-wrapper">
//       {UserData &&
//         UserData.user.map((person, index) => (
//           <div className="inner" key={index}>
//             <div className="rbt-admin-profile">
//               <div className="admin-thumbnail">
//                 <Image
//                   src={person.img}
//                   width={43}
//                   height={43}
//                   alt="User Images"
//                 />
//               </div>
//               <div className="admin-info">
//                 <span className="name">{person.name}</span>
//                 <Link
//                   className="rbt-btn-link color-primary"
//                   href="/instructor/instructor-profile"
//                 >
//                   View Profile
//                 </Link>
//               </div>
//             </div>
//             <ul className="user-list-wrapper">
//               {person.userList.map((list, innerIndex) => (
//                 <li key={innerIndex}>
//                   <Link href={list.link}>
//                     <i className={list.icon}></i>
//                     <span>{list.text}</span>
//                   </Link>
//                 </li>
//               ))}
//             </ul>
//             <hr className="mt--10 mb--10" />
//             <ul className="user-list-wrapper">
//               <li>
//                 <Link href="#">
//                   <i className="feather-book-open"></i>
//                   <span>Getting Started</span>
//                 </Link>
//               </li>
//             </ul>
//             <hr className="mt--10 mb--10" />
//             <ul className="user-list-wrapper">
//               <li>
//                 <Link href="/instructor/instructor-settings">
//                   <i className="feather-settings"></i>
//                   <span>Settings</span>
//                 </Link>
//               </li>
//               <li>
//                 {/* <Link href="/">
//                   <i className="feather-log-out"></i>
//                   <span>Logout</span>
//                 </Link> */}
//                 <Link href="/">
//                   <i className="feather-log-out"></i>
//                   <a onClick={logout}>Logout</a>
//                 </Link>
//               </li>
//             </ul>
//           </div>
//         ))}
//     </div>
//   );
// };

// export default User;
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

// Define menu structures for different roles
const menus = {
  instructor: [
    { icon: "feather-home", text: "My Dashboard", link: "/instructor/instructor-dashboard" },
    { icon: "feather-bookmark", text: "Bookmark", link: "#" },
    { icon: "feather-shopping-bag", text: "Enrolled Courses", link: "/instructor/instructor-enrolled-course" },
    { icon: "feather-heart", text: "Wishlist", link: "/instructor/instructor-wishlist" },
    { icon: "feather-star", text: "Reviews", link: "/instructor/instructor-reviews" },
    { icon: "feather-list", text: "My Quiz Attempts", link: "/instructor/instructor-my-quiz-attempts" },
    { icon: "feather-clock", text: "Order History", link: "/instructor/instructor-order-history" },
    { icon: "feather-message-square", text: "Question & Answer", link: "/instructor/instructor-quiz-attempts" }
  ],
  student: [
    { icon: "feather-home", text: "Student Dashboard", link: "/student/student-dashboard" },
    { icon: "feather-bookmark", text: "Bookmark", link: "#" },
    { icon: "feather-shopping-bag", text: "Enrolled Courses", link: "/student/student-enrolled-course" },
    { icon: "feather-shopping-bag", text: "Enrolled Events", link: "/student/student-enrolled-events" },
    { icon: "feather-heart", text: "Wishlist", link: "/student/student-wishlist" },
    { icon: "feather-star", text: "Reviews", link: "/student/student-reviews" },
    { icon: "feather-list", text: "My Quiz Attempts", link: "/student/student-my-quiz-attempts" },
    { icon: "feather-clock", text: "Order History", link: "/student/student-order-history" },
    { icon: "feather-message-square", text: "Question & Answer", link: "/student/student-quiz-attempts" }
    
  ]
};

const User = () => {
  const router = useRouter();
  const [user, setUser] = useState(null);

  const URL = `${process.env.NEXT_PUBLIC_API_URL}/logout`;

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    setUser(storedUser);
  }, []);

  const logout = async (e) => {
    e.preventDefault();
    localStorage.removeItem("user");
    localStorage.removeItem("token");

    try {
      const response = await fetch(URL, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });
      console.log("Logout:", response);
    } catch (err) {
      console.error("Logout error:", err);
    }

    router.push("/login");
  };

  if (!user) return null;

  const role = user.role || "student"; 
  const menuItems = menus[role] || [];

  return (
    <div className="rbt-user-menu-list-wrapper">
      <div className="inner">
        <div className="rbt-admin-profile">
          <div className="admin-thumbnail">
            <Image
              src={user.img || "/images/team/avatar.jpg"}
              width={43}
              height={43}
              alt="User"
            />
          </div>
          <div className="admin-info">
            <span className="name">{user.name}</span>
            <Link
              className="rbt-btn-link color-primary"
              href={`/${role}/${role}-profile`}
            >
              View Profile
            </Link>
          </div>
        </div>

        <ul className="user-list-wrapper">
          {menuItems.map((item, index) => (
            <li key={index}>
              <Link href={item.link}>
                <i className={item.icon}></i>
                <span>{item.text}</span>
              </Link>
            </li>
          ))}
        </ul>

        <hr className="mt--10 mb--10" />
        <ul className="user-list-wrapper">
          <li>
            <Link href="#">
              <i className="feather-book-open"></i>
              <span>Getting Started</span>
            </Link>
          </li>
        </ul>

        <hr className="mt--10 mb--10" />
        <ul className="user-list-wrapper">
          <li>
            <Link href={`/${role}/${role}-settings`}>
              <i className="feather-settings"></i>
              <span>Settings</span>
            </Link>
          </li>
          <li>
            <a href="#" onClick={logout}>
              <i className="feather-log-out"></i>
              <span>Logout</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default User;
